import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';

const DrilldownContainer = ({ lookupKey = '', drilldown = '' }) => {
  const [html, setHtml] = useState({ __html: '' });

  useEffect(() => {
    Api.post('report/drilldown', { lookupKey, drilldown }).then(response => {
      setHtml({ __html: response.data });
    });
  }, []);

  /* eslint-disable react/no-danger */
  return (
    <div className="react-drilldown-wrapper">
      <div dangerouslySetInnerHTML={html} />
    </div>
  );
};

DrilldownContainer.propTypes = {
  lookupKey: PropTypes.string,
  drilldown: PropTypes.string,
};

export default DrilldownContainer;
